var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useContext, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import classnames from "classnames";
import { t } from '@mp/locale';
import { analytics } from "../../communication";
import { endsWith } from "lodash";
import { OrderContext } from "../../hooks/OrderContext";
import { AppPropsContext } from "../../hooks/AppPropsContext";
import { initiateOrder, TRACKING_NAMESPACE, trackingEvents, patchOrder } from "../../services/schedulerService";
import { Loader } from "../Loader/Loader";
import { Collapse } from "@mui/material";
import { TextField } from "@mui/material";
import "../../CaptureServicesScheduler.styles.scss";
import AddressAutocomplete from "../AddressAutocomplete/AddressAutocomplete";
import PropertySpaceSelector from "./PropertySpaceSelector";
import PropertyCountry from "./PropertyCountry";
import PropertySpace from "./PropertySpace";
import { StepContext } from "../../hooks/StepContext";
import { SchedulerDataContext } from "../../hooks/SchedulerDataContext";
import PropertyMap from "./PropertyMap";
export default function PropertyDetails() {
    var _a = useContext(AppPropsContext), estimateCurrency = _a.estimateCurrency, isFreeSubscription = _a.isFreeSubscription, freeSubscriptionCallback = _a.freeSubscriptionCallback, organizationId = _a.organizationId;
    var _b = useContext(OrderContext), order = _b.order, setOrder = _b.setOrder;
    var _c = useState('US'), selectedCountry = _c[0], setSelectedCountry = _c[1];
    var _d = useState(''), suite = _d[0], setSuite = _d[1];
    var suiteRef = useRef(null);
    var _e = useState({
        description: '',
        placeid: '',
    }), addressString = _e[0], setAddressString = _e[1];
    var _f = useState(''), addressReturnStatus = _f[0], setAddressReturnStatus = _f[1];
    var _g = useState({
        desc: '',
        lat: 0.0,
        lng: 0.0
    }), notCoveredAddressLocation = _g[0], setNotCoveredAddressLocation = _g[1];
    var _h = useState(false), countriesLoaded = _h[0], setCountriesLoaded = _h[1];
    var _j = useContext(SchedulerDataContext), schedulerData = _j.schedulerData, setSchedulerData = _j.setSchedulerData;
    var section = useContext(StepContext).section;
    var _k = useState(''), captureType = _k[0], setCaptureType = _k[1];
    var _l = useState('Residential'), propertyType = _l[0], setPropertyType = _l[1];
    var _m = useState(''), cookiesCountry = _m[0], setCookiesCountry = _m[1];
    var _o = useState(''), cookiesAddress = _o[0], setCookiesAddress = _o[1];
    var _p = useState(false), resetForm = _p[0], setResetForm = _p[1];
    /*
     * Tech Debt
     * This is super buggy. It really needs to be changed
     * to a useReduer since we are updating valus
     * High potential for things to be overwritten
     * We are also using the sessionStorage sometimes
     * and not other times.
     * We really should fetch a previous order and use that
     * to set the initial data
     * as a result some fields have data set on refres
     * other fields don't.
     * It creates too many sources of truth which are
     * sometimes aligned and sometimes not aligned
     */
    var _q = useState(''), inputValues = _q[0], setInputValues = _q[1];
    var _r = useState(false), multipleSuggestions = _r[0], setMultipleSuggestions = _r[1];
    var _s = useState(true), showCoverage = _s[0], setShowCoverage = _s[1];
    var _t = useState(false), showType = _t[0], setShowType = _t[1];
    var _u = useState(false), showTypeTitle = _u[0], setShowTypeTitle = _u[1];
    var _v = useState(false), showSpace = _v[0], setShowSpace = _v[1];
    var _w = useState(false), showSpaceTitle = _w[0], setShowSpaceTitle = _w[1];
    useEffect(function () {
        switch (section) {
            case 'coverage':
                setShowCoverage(true);
                setShowType(false);
                setShowSpace(false);
                break;
            case 'space':
                setShowSpaceTitle(true);
                setShowTypeTitle(true);
                setShowCoverage(false);
                setShowType(false);
                setShowSpace(true);
                break;
            case 'type':
                setShowTypeTitle(true);
                setShowCoverage(false);
                setShowType(true);
                setShowSpace(false);
                break;
        }
    }, [section]);
    // Filling the input fields if the user tries to change address info in the summary screen just before the order confirmation
    var session = sessionStorage.getItem("order-details");
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var orderDetails = JSON.parse(session) || null;
        var sessionCaptureType = (_c = (_b = (_a = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.capture_requirements_questions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.answer_choices) === null || _c === void 0 ? void 0 : _c[0];
        if (sessionCaptureType) {
            setCaptureType(sessionCaptureType);
        }
        if (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.address) {
            if (selectedCountry !== orderDetails.address.country) {
                setCookiesCountry(orderDetails.address.country);
                setSelectedCountry(orderDetails.address.country);
                setCookiesAddress(orderDetails.address.address_string);
            }
            if (((_d = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.address) === null || _d === void 0 ? void 0 : _d.address_string) && !(addressString === null || addressString === void 0 ? void 0 : addressString.description)) {
                var address = {
                    description: (_e = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.address) === null || _e === void 0 ? void 0 : _e.address_string,
                    placeid: (_f = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.address) === null || _f === void 0 ? void 0 : _f.placeId
                };
                setAddressString(address);
            }
            setSuite(((_g = orderDetails.address) === null || _g === void 0 ? void 0 : _g.suite) || "");
            // If user get to just the previous step and go back, return in the last part of the form. If not, return to the top
            if (sessionStorage.getItem("date-selection")) {
                sessionStorage.removeItem("date-selection");
                setShowCoverage(false);
                setShowType(false);
                setShowTypeTitle(true);
                setShowSpace(true);
                setShowSpaceTitle(true);
            }
        }
        // Check against the JSON string or else it will rerun effect constantly
    }, [session]);
    /*
     * Tech Debt
     * The Cookie was not expected to store all of the informaiton
     * We were using the preorder id as the source of truth
     * That has been abandoned as part of the refactor.
     * However, it's the safest way to assure we have correct informaiton
     * Updating to use cookie, but the better approach would be preorder id
     * See below for an example
     */
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!Cookies.get("capture_service_address")) {
            return;
        }
        var returnedAddress = JSON.parse(Cookies.get("capture_service_address"));
        if (returnedAddress === null || returnedAddress === void 0 ? void 0 : returnedAddress.address) {
            // I don't know why we have both
            setCookiesCountry((_a = returnedAddress === null || returnedAddress === void 0 ? void 0 : returnedAddress.address) === null || _a === void 0 ? void 0 : _a.country);
            setSelectedCountry((_b = returnedAddress === null || returnedAddress === void 0 ? void 0 : returnedAddress.address) === null || _b === void 0 ? void 0 : _b.country);
            setSuite(((_c = returnedAddress === null || returnedAddress === void 0 ? void 0 : returnedAddress.address) === null || _c === void 0 ? void 0 : _c.suite) || "");
            setAddressString({
                description: (_d = returnedAddress === null || returnedAddress === void 0 ? void 0 : returnedAddress.address) === null || _d === void 0 ? void 0 : _d.address_string,
                placeid: (_e = returnedAddress === null || returnedAddress === void 0 ? void 0 : returnedAddress.address) === null || _e === void 0 ? void 0 : _e.place_id
            });
        }
    }, []);
    // useEffect(() => {
    //   if(schedulerData?.property_details) {
    //     setSelectedCountry(schedulerData.property_details.country);
    //     setSuite(schedulerData.property_details.suite || "")
    //     setAddressString({
    //       description: schedulerData.property_details.address_string,
    //       placeid: schedulerData.property_details.place_id
    //     })
    //   }
    // }, [JSON.stringify(schedulerData)])
    // Whenever the address input changes, update the screen
    useEffect(function () {
        if (addressString.description) {
            checkAddress();
        }
    }, [addressString]);
    useEffect(function () {
        if (inputValues) {
            var addProperty = inputValues;
            addProperty.property_type = propertyType;
            setInputValues(addProperty);
        }
    }, [propertyType]);
    useEffect(function () {
        var _a, _b;
        var orderDetails = JSON.parse(session) || null;
        // Can come from the order or session storage (saved as orderDetails)
        var captureRequirments = ((_a = order === null || order === void 0 ? void 0 : order.available_questions) === null || _a === void 0 ? void 0 : _a[0]) || ((_b = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.available_questions) === null || _b === void 0 ? void 0 : _b[0]);
        if (captureRequirments && captureType) {
            setInputValues(__assign(__assign({}, inputValues), { capture_requirements_questions: [__assign(__assign({}, captureRequirments), { answer_choices: [captureType] })] }));
        }
        // Remove if we switched to a pro2 address
        // Again, not best way to remove values. Need to use useReducer instead
        if (!captureType && inputValues.capture_requirements_questions) {
            var capture_requirements_questions = inputValues.capture_requirements_questions, rest = __rest(inputValues, ["capture_requirements_questions"]);
            setInputValues(rest);
        }
    }, [captureType, session]);
    // get the address and initiate an order
    var checkAddress = function () {
        var initialData = {
            address: {
                address_string: addressString.description,
                country: selectedCountry,
                placeId: addressString.placeid,
                suite: suite
            },
        };
        if (organizationId) {
            initialData.organization_id = organizationId;
        }
        else if (estimateCurrency) {
            initialData.estimate_currency = estimateCurrency;
        }
        analytics.track(TRACKING_NAMESPACE, trackingEvents.ADDRESS_COMPLETED, {
            cs_address: addressString.description,
            cs_country: selectedCountry,
        });
        // Saving the initial data element to forward it to the spaces component. Can't use values straight from the order details returned from the back end, since the address strings are completely different :(
        setInputValues(__assign(__assign({}, inputValues), initialData));
        initiateOrder(__assign(__assign({}, initialData), { spaces: null, total_property_size: null }))
            .then(function (response) {
            var _a, _b;
            analytics.track(TRACKING_NAMESPACE, trackingEvents.ADDRESS_AVAILABLE, {
                address_latitude: (_a = response === null || response === void 0 ? void 0 : response.address) === null || _a === void 0 ? void 0 : _a.address_latitude,
                address_longitude: (_b = response === null || response === void 0 ? void 0 : response.address) === null || _b === void 0 ? void 0 : _b.address_longitude,
                id: response === null || response === void 0 ? void 0 : response.id,
            });
            setOrder(response);
            // Always reset the scheduler since the property may have changed
            setSchedulerData({ step: "scheduler", data: null });
            setAddressReturnStatus('success');
            setMultipleSuggestions(false);
        })
            .catch(function (error) {
            var _a, _b;
            handleAddressStepError(error, initialData);
            setAddressReturnStatus(((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) || 'fail');
        });
    };
    var handleAddressStepError = function (error, data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        if ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.extra) {
            var notCoveredAddress = {
                desc: ((_e = (_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.extra) === null || _e === void 0 ? void 0 : _e.desc) || '',
                lat: parseFloat((_h = (_g = (_f = error === null || error === void 0 ? void 0 : error.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.extra) === null || _h === void 0 ? void 0 : _h.address_latitude),
                lng: parseFloat((_l = (_k = (_j = error === null || error === void 0 ? void 0 : error.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.extra) === null || _l === void 0 ? void 0 : _l.address_longitude)
            };
            setNotCoveredAddressLocation(notCoveredAddress);
        }
        if (((_o = (_m = error === null || error === void 0 ? void 0 : error.response) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.code) === "capturesvcs.exceeded_max_property_size") {
            analytics.track(TRACKING_NAMESPACE, trackingEvents.SIZE_TOO_LARGE, __assign({}, data));
            return;
        }
        if (((_q = (_p = error === null || error === void 0 ? void 0 : error.response) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.code) === "not.found") {
            analytics.track(TRACKING_NAMESPACE, trackingEvents.ADDRESS_UNAVAILABLE, {
                cs_address: (_r = data === null || data === void 0 ? void 0 : data.address) === null || _r === void 0 ? void 0 : _r.address_string,
                cs_country: (_s = data === null || data === void 0 ? void 0 : data.address) === null || _s === void 0 ? void 0 : _s.country
            });
        }
        else {
            analytics.track(TRACKING_NAMESPACE, trackingEvents.ADDRESS_UNAVAILABLE_ERROR, {
                cs_address: (_t = data === null || data === void 0 ? void 0 : data.address) === null || _t === void 0 ? void 0 : _t.address_string,
                cs_country: (_u = data === null || data === void 0 ? void 0 : data.address) === null || _u === void 0 ? void 0 : _u.country
            });
        }
    };
    var saveSuite = function (e) {
        var _a, _b;
        setSuite((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        // This is not a good way to update information
        if (inputValues === null || inputValues === void 0 ? void 0 : inputValues.address) {
            var addSuite = inputValues;
            addSuite.address.suite = (_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value;
            setInputValues(addSuite);
        }
    };
    var changeCountry = function (country) {
        sessionStorage.removeItem("order-details");
        setSelectedCountry(country);
        resetInputs();
    };
    var handleTracking = function (event) {
        var _a;
        var _b = (event === null || event === void 0 ? void 0 : event.target) || {}, name = _b.name, value = _b.value;
        if (name) {
            var eventName = "PROPERTY_DETAILS_".concat(endsWith(name, "property_size")
                ? "TOTAL_PROPERTY_SIZE"
                : name.toUpperCase(), "_ENTERED");
            if (trackingEvents[eventName]) {
                analytics.track(TRACKING_NAMESPACE, trackingEvents[eventName], (_a = {},
                    _a[name] = value,
                    _a));
            }
        }
    };
    var validAddress = function () {
        // Always update the preorder to make sure we have the most relevant info
        var initialData = {
            address: {
                address_string: addressString.description,
                country: selectedCountry,
                placeId: addressString.placeid,
                suite: suite
            },
        };
        if (organizationId) {
            initialData.organization_id = organizationId;
        }
        else if (estimateCurrency) {
            initialData.estimate_currency = estimateCurrency;
        }
        patchOrder(initialData, "property-details")
            .then(function (data) {
            setOrder(data);
        });
        setShowCoverage(false);
        setShowType(true);
        setShowTypeTitle(true);
    };
    var backToCoverage = function () {
        setShowCoverage(true);
        setShowType(false);
        setShowTypeTitle(false);
    };
    var backType = function () {
        setShowSpace(false);
        setShowSpaceTitle(false);
        setShowType(true);
        setShowTypeTitle(true);
    };
    var spaceArea = function () {
        setShowType(false);
        setShowSpace(true);
        setShowSpaceTitle(true);
    };
    var clearForm = function () {
        setResetForm(true);
        setSuite('');
    };
    // Reset - remove the map, reset all inputs and if needed, return to the address input
    var resetInputs = function () {
        setAddressReturnStatus("reset");
        setCookiesAddress('');
        setSuite('');
        setAddressString({
            description: '',
            placeid: ''
        });
        // maybe call only when needed (won't hurt anything right now, but...)
        setShowCoverage(true);
        setShowType(false);
        setShowTypeTitle(false);
        setShowSpace(false);
        setShowSpaceTitle(false);
    };
    var disableNext = function (value) {
        value === "multiple" ? setMultipleSuggestions(true) : setMultipleSuggestions(false);
    };
    return (_jsx("div", __assign({ className: "mp-capturesvc-address" }, { children: _jsxs(_Fragment, { children: [_jsx("h1", __assign({ "data-qa": "step-title", className: "mp-capturesvc-step-title" }, { children: t("CAPTURE_SERVICES.ORDER.STEPS.property_details.title") })), _jsx("p", __assign({ "data-qa": "step-subtitle", className: "mp-capturesvc-step-subtitle" }, { children: t("CAPTURE_SERVICES.ORDER.PROPERTY_DETAILS.title") })), _jsxs("h2", __assign({ "data-qa": "step-coverage-title", className: "notify-title margin-30" }, { children: [" ", t("CAPTURE_SERVICES.SCHEDULER.checkCoverage"), " "] })), _jsxs(Collapse, __assign({ in: showCoverage }, { children: [_jsxs("p", __assign({ "data-qa": "location-subtitle", className: "mp-capturesvc-step-subtitle" }, { children: [" ", t("CAPTURE_SERVICES.SCHEDULER.locationHelper"), " "] })), _jsxs("div", { children: [!countriesLoaded && _jsxs("div", __assign({ className: "spinner-spacer" }, { children: [" ", _jsx(Loader, { loaderType: "bounce" }), " "] })), _jsx(PropertyCountry, { changeCountry: function (country) { return changeCountry(country); }, loaded: function () { return setCountriesLoaded(true); }, cookie: cookiesCountry, reset: resetForm }), countriesLoaded && _jsxs("div", __assign({ className: "mp-form-row" }, { children: [_jsx(AddressAutocomplete, { addressString: addressString, country: selectedCountry, cookie: cookiesAddress, reset: addressReturnStatus, multipleSuggestions: function (value) { return disableNext(value); }, onChange: function (data, reset) {
                                                // data without description means a suggestion was not found
                                                if (reset) {
                                                    setAddressString({
                                                        description: '',
                                                        placeid: '',
                                                    });
                                                    // An odd way to disable the next button
                                                    disableNext('multiple');
                                                }
                                                if (data === null || data === void 0 ? void 0 : data.description) {
                                                    setAddressString(data);
                                                    disableNext('single');
                                                }
                                            } }), _jsx(TextField, { id: "suite", name: "suite", className: "suite-placement scheduler-inputs", disabled: !selectedCountry, "data-qa": "property-suite-number", label: t("CAPTURE_SERVICES.SCHEDULER.ADDRESS.unit.label"), inputRef: suiteRef, value: suite, onChange: saveSuite, variant: "standard" })] })), _jsx(PropertyMap, { address: addressString, coveredAddress: addressReturnStatus, notCoveredAddressLocation: notCoveredAddressLocation, nextButton: validAddress, inputValues: inputValues, inputReset: resetInputs, buttonDisabled: multipleSuggestions })] })] })), _jsx("h2", __assign({ "data-qa": "property-spaces-title", className: classnames("notify-title margin-bottom-30", {
                        "cs-disabled": !showTypeTitle
                    }) }, { children: t("CAPTURE_SERVICES.ORDER.PROPERTY_SIZE.title") })), _jsx(Collapse, __assign({ in: showType }, { children: _jsx("div", { children: _jsx(PropertySpaceSelector, { backStep: backToCoverage, captureType: captureType, handleTracking: handleTracking, nextStep: spaceArea, propertyType: propertyType, setCaptureType: function (ev) { return setCaptureType(ev); }, setPropertyType: function (ev) { return setPropertyType(ev); } }) }) })), _jsx("h2", __assign({ "data-qa": "property-spaces-title", className: classnames("notify-title margin-bottom-30", {
                        "cs-disabled": !showSpaceTitle
                    }) }, { children: t("CAPTURE_SERVICES.ORDER.STEPS.property_details.label") })), _jsx(Collapse, __assign({ in: showSpace }, { children: _jsx(PropertySpace, { suiteNumber: suite, propertyType: propertyType, captureType: captureType, backStep: backType, inputFields: inputValues, inputReset: resetInputs }) }))] }) })));
}
